import { TennisPerformanceCategory } from '../../enums/tennis-performance-category.enum';

export const TENNIS_PERFORMANCE_CATEGORY_BY_MARKET: Record<string, TennisPerformanceCategory> = {
	'Total Games': TennisPerformanceCategory.MatchFormat,
	'Total Sets': TennisPerformanceCategory.MatchFormat,
	'Total Games Odd/Even': TennisPerformanceCategory.MatchFormat,
	'Total Tie Breaks': TennisPerformanceCategory.MatchFormat,

	Moneyline: TennisPerformanceCategory.ServePerformance,
	'Game Spread': TennisPerformanceCategory.ServePerformance,
	'Correct Score': TennisPerformanceCategory.ServePerformance,
	'Both Players To Win A Set': TennisPerformanceCategory.ServePerformance,

	'Player Aces': TennisPerformanceCategory.ErrorsShotMaking,
	'Player Double Faults': TennisPerformanceCategory.ErrorsShotMaking,

	'Set Handicap': TennisPerformanceCategory.SetLevelOutcomes,
	'1st Set Moneyline': TennisPerformanceCategory.SetLevelOutcomes,
	'2nd Set Moneyline': TennisPerformanceCategory.SetLevelOutcomes,
	'3rd Set Moneyline': TennisPerformanceCategory.SetLevelOutcomes,
	'1st Set Total Games': TennisPerformanceCategory.SetLevelOutcomes,
	'2nd Set Total Games': TennisPerformanceCategory.SetLevelOutcomes,
	'3rd Set Total Games': TennisPerformanceCategory.SetLevelOutcomes,
	'Player Games Won': TennisPerformanceCategory.SetLevelOutcomes,
};

export const TENNIS_PERFORMANCE_CATEGORY_BY_SEEDED_CATEGORY: Record<
	string,
	TennisPerformanceCategory
> = {
	'Main Lines': TennisPerformanceCategory.ServePerformance,
	'Set Props': TennisPerformanceCategory.SetLevelOutcomes,
	'Player Props': TennisPerformanceCategory.ErrorsShotMaking,
};
